export default "__VITE_ASSET__BRUIHbAq__"